import {
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getCarDetailDataMaster(versionId) {

    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_DATA_MASTER_BEGIN,
        data: {versionId}
      })
    }
  }